import {ODATA_COLUMN_TYPES} from "../../utils/odata";

export const STEP_FILE = "fileUpload";
export const STEP_COLUMN = "columnSelection";
export const STEP_TYPE = "columnType";

export const CSV_MODE_DEFAULT = "Default";
export const CSV_MODE_ESCAPE = "Escape";
export const CSV_MODE_NO_ESCAPE = "NoEscape";

export const getCsvModeOptions = t => [
  {id: CSV_MODE_DEFAULT, label: t("modules.packageManager.etlWizard.csvFormatDialog.fields.csvMode.values.default")},
  {id: CSV_MODE_ESCAPE, label: t("modules.packageManager.etlWizard.csvFormatDialog.fields.csvMode.values.escape")},
  {id: CSV_MODE_NO_ESCAPE, label: t("modules.packageManager.etlWizard.csvFormatDialog.fields.csvMode.values.noEscape")}
];

export const COLUMN_TYPES = {
  generic: "Generic",
  coded: "Coded",
  measure: "Measure"
};

export const getColumnTypes = t => ({
  [COLUMN_TYPES.generic]: t("modules.packageManager.etlWizard.columnTypes.generic"),
  [COLUMN_TYPES.coded]: t("modules.packageManager.etlWizard.columnTypes.coded"),
  [COLUMN_TYPES.measure]: t("modules.packageManager.etlWizard.columnTypes.measure"),
  coordinates: t("modules.packageManager.etlWizard.columnTypes.coordinates"),
  temporal: t("modules.packageManager.etlWizard.columnTypes.temporal")
});

export const getGenericTypes = t => [
  {id: "None", label: t("modules.packageManager.etlWizard.genericTypes.none")},
  {id: ODATA_COLUMN_TYPES.image, label: t("modules.packageManager.etlWizard.genericTypes.image")},
  {id: ODATA_COLUMN_TYPES.addr, label: t("modules.packageManager.etlWizard.genericTypes.addr")},
  {id: ODATA_COLUMN_TYPES.website, label: t("modules.packageManager.etlWizard.genericTypes.website")},
  {id: ODATA_COLUMN_TYPES.phone, label: t("modules.packageManager.etlWizard.genericTypes.phone")},
  {id: ODATA_COLUMN_TYPES.note, label: t("modules.packageManager.etlWizard.genericTypes.note")},
  {id: ODATA_COLUMN_TYPES.mail, label: t("modules.packageManager.etlWizard.genericTypes.email")},
  {id: ODATA_COLUMN_TYPES.identifier, label: t("modules.packageManager.etlWizard.genericTypes.identifier")}
];

export const getTemporalTypes = t => [
  {id: ODATA_COLUMN_TYPES.year, label: t("modules.packageManager.etlWizard.genericTypes.year")},
  {id: ODATA_COLUMN_TYPES.semester, label: t("modules.packageManager.etlWizard.genericTypes.semester")},
  {id: ODATA_COLUMN_TYPES.quadrimester, label: t("modules.packageManager.etlWizard.genericTypes.quadrimester")},
  {id: ODATA_COLUMN_TYPES.quarter, label: t("modules.packageManager.etlWizard.genericTypes.quarter")},
  {id: ODATA_COLUMN_TYPES.month, label: t("modules.packageManager.etlWizard.genericTypes.month")},
  {id: ODATA_COLUMN_TYPES.day, label: t("modules.packageManager.etlWizard.genericTypes.day")},
  {id: ODATA_COLUMN_TYPES.dateTime, label: t("modules.packageManager.etlWizard.genericTypes.dateTime")},
  {id: ODATA_COLUMN_TYPES.time, label: t("modules.packageManager.etlWizard.genericTypes.time")}
];

export const getCoordinatesTypes = t => [
  {id: ODATA_COLUMN_TYPES.lat, label: t("modules.packageManager.etlWizard.genericTypes.lat")},
  {id: ODATA_COLUMN_TYPES.lon, label: t("modules.packageManager.etlWizard.genericTypes.lon")}
];

export const getMeasureUnit = t => [
  {id: "None", label: t("modules.packageManager.etlWizard.measureUnit.none")},
  {id: "PERC", label: t("modules.packageManager.etlWizard.measureUnit.perc")},
  {id: "CURR", label: t("modules.packageManager.etlWizard.measureUnit.curr")}
];

export const getMeasureDecimals = t => [
  {id: 0, label: t("modules.packageManager.etlWizard.measureDecimals.integer")},
  {id: 1, label: t("modules.packageManager.etlWizard.measureDecimals.oneDigit")},
  {id: 2, label: t("modules.packageManager.etlWizard.measureDecimals.twoDigits")},
  {id: 3, label: t("modules.packageManager.etlWizard.measureDecimals.threeDigits")},
  {id: 4, label: t("modules.packageManager.etlWizard.measureDecimals.fourDigits")}
];

export const getDecimalSeparators = t => [
  {id: ".", label: t("modules.packageManager.etlWizard.decimalSeparator.dot")},
  {id: ",", label: t("modules.packageManager.etlWizard.decimalSeparator.comma")}
];

export const INITIAL_COLUMN_TYPE = {
  dimensionType: COLUMN_TYPES.generic,
  genericDimensionType: "None",
  hasError: false
};
